import { Typography } from "antd";
import { PropsWithChildren, type ReactElement } from "react";
import styled, { css } from "styled-components";

export interface SettingGroupProps {
  label: string;
  sidebarExpanded: boolean;
}

export default function SettingGroup({ children, label, sidebarExpanded }: PropsWithChildren<SettingGroupProps>): ReactElement {
  return (
    <SettingGroupBox $sidebarExpanded={sidebarExpanded} role="group">
      {
        sidebarExpanded &&
        <GroupLabel>{label}</GroupLabel>
      }
      <div>
        {children}
      </div>
    </SettingGroupBox>
  );
}

const SettingGroupBox = styled.div<{ $sidebarExpanded: boolean }>`
  ${p => p.$sidebarExpanded &&
    css`
      padding: ${p => p.theme.paddingXS}px;
      border-radius: ${p => p.theme.borderRadius}px;
      border: ${p => p.theme.lineWidth}px ${p => p.theme.lineType} ${p => p.theme.colorBorder};
      box-shadow: ${p => p.theme.boxShadowTertiary};
    `
  }

  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.paddingXXS}px;
`;

const GroupLabel = styled(Typography.Title).attrs({ level: 5 })`
  &&& {
    margin: 0;
    white-space: nowrap;
  }
`;
